import React from "react";
import { PIECE } from "./utils/c4Logic";

const PIECE_COLORS = {
  [PIECE.ONE]: {
    background: "linear-gradient(145deg, #356da4 0%, #17375f 52%, #07111f 100%)",
    borderColor: "rgba(2,6,8,0.98)",
    glow: "rgba(15,36,68,0.46)",
  },
  [PIECE.TWO]: {
    background: "linear-gradient(145deg, #8f1212 0%, #520808 48%, #190202 100%)",
    borderColor: "rgba(2,6,8,0.98)",
    glow: "rgba(69,10,10,0.52)",
  },
};

const HOVER_COLORS = {
  [PIECE.ONE]: {
    borderColor: "rgba(53,109,164,0.72)",
    background: "rgba(53,109,164,0.16)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14), 0 0 16px rgba(53,109,164,0.22)",
  },
  [PIECE.TWO]: {
    borderColor: "rgba(143,18,18,0.72)",
    background: "rgba(143,18,18,0.16)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14), 0 0 16px rgba(143,18,18,0.24)",
  },
};

export default function ConnectFourCell({ piece, isWinCell, isHovered, hoverPiece, isLastDrop }) {
  const filled = piece !== PIECE.NONE;

  const meta = PIECE_COLORS[piece];
  const pieceClass = filled
    ? [
        "h-full w-full rounded-full border-[3px] shadow-[inset_0_2px_0_rgba(255,255,255,0.10),inset_0_-10px_18px_rgba(0,0,0,0.34),0_10px_20px_rgba(0,0,0,0.44)]",
        isWinCell ? "ring-2 ring-[#C6A15B] ring-offset-2 ring-offset-[#030607]" : "",
        isLastDrop ? "animate-[dropIn_0.25s_ease-out]" : "",
      ].join(" ")
    : isHovered && hoverPiece
    ? "h-full w-full rounded-full border"
    : null;
  const hoverMeta = HOVER_COLORS[hoverPiece];

  return (
    <div className="p-[3px] sm:p-[4px]">
      <div className="w-full aspect-square rounded-full border border-black/55 bg-[radial-gradient(circle_at_50%_42%,#111827,#030607_70%)] shadow-[inset_0_3px_10px_rgba(0,0,0,0.72),inset_0_-1px_0_rgba(255,255,255,0.04)] overflow-hidden flex items-center justify-center">
        {pieceClass && (
          <div
            className={pieceClass}
            style={filled && meta ? {
              background: meta.background,
              borderColor: meta.borderColor,
              boxShadow: `inset 0 4px 10px rgba(255,255,255,0.12), inset 0 -8px 16px rgba(0,0,0,0.3), 0 10px 20px rgba(0,0,0,0.44), 0 0 22px ${meta.glow}`,
            } : hoverMeta}
          />
        )}
      </div>
    </div>
  );
}
